import React from 'react'
import Footer from '../Footer/Footer'
import ModelSlider from './ModelSlider'
import styled from 'styled-components'
import axios from 'axios';
import { useState } from 'react';
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ConfigProvider, Pagination } from 'antd';
import Topnav from '../TopNav/Topnav';
import Header from '../Header';
import Singer from '../Singer/Singer';
import Dancer from '../Dancer/Dancer';
import Musician from '../Musician/Musician';
import Anchor from '../Anchor/Anchor';

const API_URL = process.env.REACT_APP_API_URL;
const Token = localStorage.getItem("JwtToken");

// Improved shuffle function with unique ID tracking
const shuffleArray = (array) => {
  if (!array || array.length === 0) return [];
  
  const newArray = [...array];
  const seenIds = new Set();
  const uniqueArray = [];
  
  // First, remove duplicates based on ID
  for (let i = 0; i < newArray.length; i++) {
    const item = newArray[i];
    const itemId = item.id + (item.type || ''); // Combine ID with type to avoid conflicts
    if (!seenIds.has(itemId)) {
      seenIds.add(itemId);
      uniqueArray.push(item);
    }
  }
  
  // Then shuffle the unique array
  for (let i = uniqueArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [uniqueArray[i], uniqueArray[j]] = [uniqueArray[j], uniqueArray[i]];
  }
  
  return uniqueArray;
};

const Model = () => {
  const navigate = useNavigate();
  
  const [searchQuery, setSearchQuery] = useState('');
  const [searchQuery1, setSearchQuery1] = useState('');
  const [searchQuery2, setSearchQuery2] = useState('');
  const [current, setCurrent] = useState(1);
  const [current1, setCurrent1] = useState(1);
  const [current2, setCurrent2] = useState(1);
  const [pageSize] = useState(10);
  const [pageSize1] = useState(10);
  const [pageSize2] = useState(10);
  const [maleModel, setMaleModel] = useState([]);
  const [femaleModel, setFemaleModel] = useState([]);
  const [childArtist, setChildArtist] = useState([]);
  const [noMovie, setNoMovie] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Move the option1 declaration inside the component function
  const option1 = {
    headers: {
      'Authorization': `Bearer ${Token}`
    },
  };

  // Navigation functions for View All buttons
  const viewAllMale = () => {
    navigate('/models/male');
  };
  
  const viewAllFemale = () => {
    navigate('/models/female');
  };
  
  const viewAllChild = () => {
    navigate('/models/child');
  };

  const handleOpenModal = () => {
    setModalVisible(true);
  };
  
  const handleCloseModal = () => {
    setModalVisible(false);
  };

  const getMaleModel = async () => {
    try {
      const [modelsRes, agentModelsRes] = await Promise.all([
        axios.get(`${API_URL}/api/models?filters[Category][$eq]=Male&filters[Payment][$eq]=Paid&populate=*&pagination[pageSize]=100`),
        axios.get(`${API_URL}/api/agent-models?filters[Category][$eq]=Male&filters[Payment][$eq]=Paid&populate=*&pagination[pageSize]=100`)
      ]);
    
      const modelsData = modelsRes.data.data.map(item => ({
        ...item,
        type: "model",
        uniqueId: `model-${item.id}`
      }));
  
      const agentModelsData = agentModelsRes.data.data.map(item => ({
        ...item,
        type: "agent-model",
        uniqueId: `agent-model-${item.id}`
      }));
  
      const combinedModels = [...modelsData, ...agentModelsData];
      // Shuffle the male models array
      setMaleModel(shuffleArray(combinedModels));
    } catch (err) {
      console.error(err);
    }
  };
  
  const getFemaleModel = async () => {
    try {
      const [femaleModelsRes, agentFemaleModelsRes] = await Promise.all([
        axios.get(`${API_URL}/api/models?filters[Category][$eq]=Female&filters[Payment][$eq]=Paid&populate=*&pagination[pageSize]=100`),
        axios.get(`${API_URL}/api/agent-models?filters[Category][$eq]=Female&filters[Payment][$eq]=Paid&populate=*&pagination[pageSize]=100`)
      ]);
  
      const femaleModelsData = femaleModelsRes.data.data.map(item => ({
        ...item,
        type: "model",
        uniqueId: `model-${item.id}`
      }));
  
      const agentFemaleModelsData = agentFemaleModelsRes.data.data.map(item => ({
        ...item,
        type: "agent-model",
        uniqueId: `agent-model-${item.id}`
      }));
  
      const combinedFemaleModels = [...femaleModelsData, ...agentFemaleModelsData];
      // Shuffle the female models array
      setFemaleModel(shuffleArray(combinedFemaleModels));
    } catch (err) {
      console.error(err);
    }
  };
  
  const getChildArtist = async () => {
    try {
      const [childModelsRes, agentChildModelsRes] = await Promise.all([
        axios.get(`${API_URL}/api/models?filters[Category][$eq]=ChildArtist&filters[Payment][$eq]=Paid&populate=*&pagination[pageSize]=100`),
        axios.get(`${API_URL}/api/agent-models?filters[Category][$eq]=ChildArtist&filters[Payment][$eq]=Paid&populate=*&pagination[pageSize]=100`)
      ]);
  
      const childModelsData = childModelsRes.data.data.map(item => ({
        ...item,
        type: "model",
        uniqueId: `model-${item.id}`
      }));
  
      const agentChildModelsData = agentChildModelsRes.data.data.map(item => ({
        ...item,
        type: "agent-model",
        uniqueId: `agent-model-${item.id}`
      }));
  
      const combinedChildModels = [...childModelsData, ...agentChildModelsData];
      // Shuffle the child artist array
      setChildArtist(shuffleArray(combinedChildModels));
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await Promise.all([getMaleModel(), getFemaleModel(), getChildArtist()]);
      setIsLoading(false);
    };
    
    fetchData();
  }, []);

  const filteredMovies = maleModel.filter(movie => {
    if (searchQuery && !movie.attributes.Name.toLowerCase().includes(searchQuery.toLowerCase())) {
      return false;
    }
    return true;
  });
  const currentPageMovies = filteredMovies.slice((current - 1) * pageSize, current * pageSize);

  const onChange = (page) => {
    setCurrent(page);
  };

  const filteredMovies1 = femaleModel.filter(movie => {
    if (searchQuery1 && !movie.attributes.Name.toLowerCase().includes(searchQuery1.toLowerCase())) {
      return false;
    }
    return true;
  });
  const currentPageMovies1 = filteredMovies1.slice((current1 - 1) * pageSize1, current1 * pageSize1);

  const onChange1 = (page) => {
    setCurrent1(page);
  };

  const filteredMovies2 = childArtist.filter(movie => {
    if (searchQuery2 && !movie.attributes.Name.toLowerCase().includes(searchQuery2.toLowerCase())) {
      return false;
    }
    return true;
  });
  const currentPageMovies2 = filteredMovies2.slice((current2 - 1) * pageSize2, current2 * pageSize2);

  const onChange2 = (page) => {
    setCurrent2(page);
  };

  if (isLoading) {
    return (
      <>
        <Topnav/>
        <Header/>
        <Container>
          <ModelSlider/>
          <LoadingMessage>Loading models...</LoadingMessage>
        </Container>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Topnav/>
      <Header/>
      <Container>
        <ModelSlider/>
        {/* Model content starts */}
        <Toolbar>
          <SectionHeader>
            <p
              style={{
                fontWeight: "bold",
                textTransform: "uppercase",
                marginRight: "10px",
              }}
            >
              Male Artist 
            </p>
            <ViewAllButton onClick={viewAllMale}>
              View All
            </ViewAllButton>
          </SectionHeader>
          <SearchInput
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </Toolbar>

        <Content1>
          {currentPageMovies && currentPageMovies.map((model) => (
            <div key={model.uniqueId}>
              <Link
                to={`/${model.type}/${model.id}`}
                onClick={() => window.scrollTo(0, 0)}
              >
                <div className="movieTrailers-container">
                  <img 
                    src={`${API_URL}${model.attributes?.Poster?.data?.attributes?.url}`} 
                    alt={model.attributes.Name} 
                    onError={(e) => {
                      e.target.src = '/placeholder-image.jpg';
                    }}
                  />
                  <div className="Movietrailers-overlay">
                    <p className="movieTrailers-title">{model.attributes.Name}</p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </Content1>

        <PaginationWrapper>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: "#e50914",
                colorText: "#ffffff",
                colorIcon: "#e50914",
              },
              components: {
                Pagination: {
                  colorPrimary: "#e50914",
                  itemSize: "42px",
                  fontSize: "22px",
                  borderRadius: "20px",
                  colorBgTextHover: "#e50914",
                },
              },
            }}
          >
            <Pagination
              className="pagination"
              size="small"
              current={current}
              onChange={onChange}
              total={filteredMovies.length}
              showSizeChanger={false}
              pageSize={pageSize}
            />
          </ConfigProvider>
        </PaginationWrapper>
        
        {/* Female Artist Section */}
        <Toolbar>
          <SectionHeader>
            <p
              style={{
                fontWeight: "bold",
                textTransform: "uppercase",
                marginRight: "10px",
              }}
            >
              Female Artist
            </p>
            <ViewAllButton onClick={viewAllFemale}>
              View All
            </ViewAllButton>
          </SectionHeader>
          <SearchInput
            type="text"
            placeholder="Search..."
            value={searchQuery1}
            onChange={(e) => setSearchQuery1(e.target.value)}
          />
        </Toolbar>

        <Content1>
          {currentPageMovies1 && currentPageMovies1.map((model) => (
            <div key={model.uniqueId}>
              <Link
                to={`/${model.type}/${model.id}`}
                onClick={() => window.scrollTo(0, 0)}
              >
                <div className="movieTrailers-container">
                  <img 
                    src={`${API_URL}${model.attributes?.Poster?.data?.attributes?.url}`} 
                    alt={model.attributes.Name}
                    onError={(e) => {
                      e.target.src = '/placeholder-image.jpg';
                    }}
                  />
                  <div className="Movietrailers-overlay">
                    <p className="movieTrailers-title">{model.attributes.Name}</p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </Content1>

        <PaginationWrapper>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: "#e50914",
                colorText: "#ffffff",
                colorIcon: "#e50914",
              },
              components: {
                Pagination: {
                  colorPrimary: "#e50914",
                  itemSize: "42px",
                  fontSize: "22px",
                  borderRadius: "20px",
                  colorBgTextHover: "#e50914",
                },
              },
            }}
          >
            <Pagination
              className="pagination"
              size="small"
              current={current1}
              onChange={onChange1}
              total={filteredMovies1.length}
              showSizeChanger={false}
              pageSize={pageSize1}
            />
          </ConfigProvider>
        </PaginationWrapper>

        {/* Child Artist Section */}
        <Toolbar>
          <SectionHeader>
            <p
              style={{
                fontWeight: "bold",
                textTransform: "uppercase",
                marginRight: "10px",
              }}
            >
              Child Artist
            </p>
            {/* <ViewAllButton onClick={viewAllChild}>
              View All
            </ViewAllButton> */}
            
          </SectionHeader>
          <SearchInput
            type="text"
            placeholder="Search..."
            value={searchQuery2}
            onChange={(e) => setSearchQuery2(e.target.value)}
          />
        </Toolbar>

        <Content1>
          {currentPageMovies2 && currentPageMovies2.map((model) => (
            <div key={model.uniqueId}>
              <Link
                to={`/${model.type}/${model.id}`}
                onClick={() => window.scrollTo(0, 0)}
              >
                <div className="movieTrailers-container">
                  <img 
                    src={`${API_URL}${model.attributes?.Poster?.data?.attributes?.url}`} 
                    alt={model.attributes.Name}
                    onError={(e) => {
                      e.target.src = '/placeholder-image.jpg';
                    }}
                  />
                  <div className="Movietrailers-overlay">
                    <p className="movieTrailers-title">{model.attributes.Name}</p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </Content1>

        <PaginationWrapper>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: "#e50914",
                colorText: "#ffffff",
                colorIcon: "#e50914",
              },
              components: {
                Pagination: {
                  colorPrimary: "#e50914",
                  itemSize: "42px",
                  fontSize: "22px",
                  borderRadius: "20px",
                  colorBgTextHover: "#e50914",
                },
              },
            }}
          >
            <Pagination
              className="pagination"
              size="small"
              current={current2}
              onChange={onChange2}
              total={filteredMovies2.length}
              showSizeChanger={false}
              pageSize={pageSize2}
            />
          </ConfigProvider>
        </PaginationWrapper>

        {/* Model content ends */}
      </Container>

      <Singer/>
      <Dancer/>
      <Musician/>
      <Anchor/>
      <Footer />
    </>
  );
}

export default Model;

const Container = styled.main`
  min-height: calc(100vh - 70px);
  padding: 0 calc(3.5vw + 5px);
  position: relative;
  padding-bottom: 50px;
  overflow-x: hidden;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
  }
`;

const LoadingMessage = styled.div`
  text-align: center;
  padding: 50px;
  font-size: 20px;
  color: #fff;
`;

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const Content1 = styled.div`
  cursor: pointer;
  display: grid;
  grid-gap: 25px;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  
  img {
    width: 100%;
    height: 250px;
    object-fit: cover;
    opacity: 0.9;
    transition: transform 0.3s ease;
    
    &:hover {
      transform: scale(1.05);
    }
  }
  
  @media (max-width: 1200px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  
  @media (max-width: 900px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-gap: 15px;
    
    img {
      height: 200px;
    }
  }
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    
    img {
      height: 250px;
    }
  }
`;

const Toolbar = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  justify-content: space-between;
  padding: 15px;
  background-color: #101011;

  p {
    font-size: 20px;
    @media (max-width: 768px) {
      font-size: 15px;
    }
  }

  @media (max-width: 768px) {
    padding: 10px;
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`;

const ViewAllButton = styled.button`
  background-color: #e50914;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #f40612;
  }
  
  @media (max-width: 768px) {
    padding: 6px 12px;
    font-size: 12px;
  }
`;

const SearchInput = styled.input`
  margin-right: 10px;
  padding: 15px;
  border: 0px inset #ff0015;
  background-color: #212529;
  border-radius: 5px;
  color: #fba010;
  float: right;
  width: 30%;
  
  @media (max-width: 768px) {
    width: 100%;
    padding: 10px;
    margin-right: 0;
  }
`;




